//noinspection JSValidateTypes
export default angular.module("lastFilter", [])
  .filter("last", lastFilter)
  .name;

const $inject = [];

function lastFilter() {
  return function (items) {
    if (items === null) {
      return null;
    }
    if (items.length !== undefined) {
      return items[items.length - 1];
    }
    return items;
  };
}

lastFilter.$inject = $inject;



/** WEBPACK FOOTER **
 ** D:/server/Apache24/htdocs/hmr/app/HMRX_App/scripts/src/filters/last.filter.js
 **/